import React, { useState, useEffect } from "react";

const styles = {
  late: {
    color: "red",
  },
  early: {
    color: "green",
  },
  dup: {
    color: "black",
  },
};

const LateBy = ({ schedule, lst }) => {
  const [timeDifference, setTimeDifference] = useState("");
  const [isLate, setIsLate] = useState(false);

  useEffect(() => {
    const updateTimeDifference = () => {
      try {
        // Parse scheduled time correctly
        const inPSTTime =
          schedule.time_.slice(0, -3) + schedule.created_at.slice(-6, -3);
        const combinedDateTime = `${schedule.date_} ${inPSTTime}`;
        const scheduledTime = new Date(combinedDateTime);

        // Get current time
        const now = new Date();
        const diff = now - scheduledTime;

        // Update late status
        setIsLate(diff > 0);

        // Only calculate time difference if it's late
        if (diff > 0) {
          const totalSeconds = Math.floor(diff / 1000);
          const totalMinutes = Math.floor(totalSeconds / 60);
          const hours = Math.floor(totalMinutes / 60);
          const minutes = totalMinutes % 60;
          const seconds = totalSeconds % 60;

          const timeStr = `${hours}h ${minutes}m ${seconds}s`;
          setTimeDifference(timeStr);
        } else {
          setTimeDifference("0h 0m 0s");
        }
      } catch (error) {
        console.error("Error calculating time difference:", error);
        setTimeDifference("Error");
      }
    };

    // Initial update
    updateTimeDifference();

    // Update every second
    const intervalId = setInterval(updateTimeDifference, 1000);
    return () => clearInterval(intervalId);
  }, [schedule.date_, schedule.time_, schedule.created_at]);

  // Don't show anything if the schedule has audio or is in the no-show list
  if (schedule.more_audios?.length > 0 || lst.includes(schedule.id)) {
    return <div style={styles.early}>{timeDifference}</div>;
  }

  if (timeDifference === "0h 0m 0s") {
    return <div style={styles.early}>{timeDifference}</div>;
  }

  return <div style={styles.late}>{timeDifference}</div>;
};

export default LateBy;
